import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {confirmAlert} from "react-confirm-alert";
import {TextField} from "@material-ui/core";
import API from "@beardeddevops/react.api";
import Types from "../constants/Types";

export default class Lockable extends Framework.Components.View {

	constructor(props) {
		super(props);

		this.lockModel = new API.BuildClass(Types.Accounts._name, API.RequestType.READ);

		this.doing = null;
		this.doingFor = null;
		this.state.pin_1 = '';
		this.state.pin_2 = '';
		this.state.pin_3 = '';
		this.state.pin_4 = '';
		this.state.location = '';
		this.state.location_error = '';
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (prevState.pin_1 !== this.state.pin_1 ||
			prevState.pin_2 !== this.state.pin_2 ||
			prevState.pin_3 !== this.state.pin_3 ||
			prevState.pin_4 !== this.state.pin_4 ||
			prevState.location !== this.state.location ||
			prevState.location_error !== this.state.location_error) {
			if (this.doing === 'locking') {
				this.handleSetPin();
			} else {
				this.handleUnlockPin();
			}
		}
	}

	handleLock = () => {
		this.lockModel.object.kiosk_mode = this.doingFor;
		this.lockModel.object.pin = this.state.pin_1 + this.state.pin_2 + this.state.pin_3 + this.state.pin_4;
		this.lockModel.object.location = this.state.location;
		// noinspection JSIgnoredPromiseFromCall
		this.lockModel.submit(null, 'GET_LOCK').then(() => {
			let locationID = this.state.location;
			//Don't trigger a component did update.
			this.doing = null;
			this.doingFor = null;
			this.state.pin_1 = '';
			this.state.pin_2 = '';
			this.state.pin_3 = '';
			this.state.pin_4 = '';
			this.state.location = '';
			this.state.location_error = '';
			this.props.reloadShell();
			if (this.lockModel.object.kiosk_mode === 1) {
				this.props.history.push('/dispositions/one_page');
			}
			if (this.lockModel.object.kiosk_mode === 2) {
				this.props.history.push('/locations/' + locationID);
			}
		});
		return false;
	};

	handleUnlock = () => {
		this.lockModel.object.kiosk_mode = 1;
		this.lockModel.object.pin = this.state.pin_1 + this.state.pin_2 + this.state.pin_3 + this.state.pin_4;
		// noinspection JSIgnoredPromiseFromCall
		this.lockModel.submit(null, 'DELETE_LOCK').then(() => {
			//Don't trigger a component did update.
			this.doing = null;
			this.doingFor = null;
			this.state.pin_1 = '';
			this.state.pin_2 = '';
			this.state.pin_3 = '';
			this.state.pin_4 = '';
			this.state.location = '';
			this.state.location_error = '';
			this.props.reloadShell();
			if (this.lockModel.object.kiosk_mode === 1) {
				this.props.history.push('/dispositions/one_page');
			}
			if (this.lockModel.object.kiosk_mode === 2) {
				this.props.history.push('/dashboard');
			}
		});
		return false;
	};

	setPin = (event) => {
		let next = event.target.getAttribute('data-next');
		let newValue = event.target.value;
		if (
			newValue === '' ||
			(parseInt(newValue) >= 0 && newValue.length === 1)
		) {
			this.setState({[event.target.name]: newValue}, () => {
				if (newValue !== '' && next) {
					document.getElementsByName(next)[0].focus();
				}
			});
		}
	};

	handleKeyPress = (onClose) => (event) => {
		let previous = event.target.getAttribute('data-previous');
		if (event.key === 'Enter' && typeof onClose === 'function') {
			if( this.doing === 'locking' ) {
				this.handleLock();
			} else {
				this.handleUnlock();
			}
			onClose();
		}
		if (event.key === 'Backspace' && previous) {
			document.getElementsByName(previous)[0].focus();
		}
	}

	handleSelectPropertyUpdate = (property, value, linked, object) => {
		if (linked) {
			this.setState({
				[linked]: object,
				[property]: value,
				[property + '_error']: '',
			});
		} else {
			this.setState({
				[property]: value,
				[property + '_error']: '',
			});
		}
	};

	handleSetPin = (mode) => {
		this.doing = 'locking';
		if( typeof mode !== 'undefined' && mode ) {
			this.doingFor = mode;
		}
		confirmAlert({
			closeOnClickOutside: false,
			customUI: ({onClose}) => {
				return (
					<div className="react-confirm-alert">
						<div className="react-confirm-alert-body">
							<h1>Create PIN</h1>
							{this.doingFor === 2 && <div className={'form-group'}>
								<div className="row">
									<div className="col-4">
										<span className="input-label">Location</span>
									</div>
									<div className="col-8">
										<Framework.Elements.Select
											shouldLoad={true}
											update={this.handleSelectPropertyUpdate}
											objects={this.props.locations}
											property={this.lockModel.properties.location}
											value={this.state.location}
											error={this.state.location_error}
											text={'name_display|name'}
											nullable={false}
											filter={
												/** @param {Locations_Properties} option */
												(option) => !option.archived
											}
										/>
									</div>
								</div>
							</div>}

							<div className={'row'}>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_1"
										value={this.state.pin_1}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress()}
										type={'number'}
										inputProps={{
											'data-next': 'pin_2',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_2"
										value={this.state.pin_2}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress()}
										type={'number'}
										inputProps={{
											'data-previous': 'pin_1',
											'data-next': 'pin_3',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_3"
										value={this.state.pin_3}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress()}
										type={'number'}
										inputProps={{
											'data-previous': 'pin_2',
											'data-next': 'pin_4',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_4"
										value={this.state.pin_4}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress(onClose)}
										type={'number'}
										inputProps={{
											'data-previous': 'pin_3',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
							</div>
							<div style={{justifyContent: 'flex-end'}} className="react-confirm-alert-button-group">
								<div>
									<button onClick={() => {
										this.doing = null;
										this.doingFor = null;
										this.state.pin_1 = '';
										this.state.pin_2 = '';
										this.state.pin_3 = '';
										this.state.pin_4 = '';
										this.state.location = '';
										this.state.location_error = '';
										onClose();
									}} style={{marginRight: '0', marginLeft: '10px'}} className={'btn btn-default'}>Cancel
									</button>
									<button style={{marginRight: '0', marginLeft: '10px'}} className={'btn btn-success'}
										onClick={() => {
											this.handleLock();
											onClose();
										}}
									>
										Lock
									</button>
								</div>
							</div>
						</div>
					</div>
				);
			}
		});
		let firstPin = document.getElementsByName('pin_1')[0] || null;
		if (firstPin && firstPin.value === '') {
			firstPin.focus();
		}
	};

	handleUnlockPin = () => {
		this.doing = 'unlocking';
		this.doingFor = null;
		confirmAlert({
			closeOnClickOutside: false,
			customUI: ({onClose}) => {
				return (
					<div className="react-confirm-alert">
						<div className="react-confirm-alert-body">
							<h1>Unlock PIN</h1>
							<div className={'row'}>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_1"
										value={this.state.pin_1}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress()}
										type={'number'}
										inputProps={{
											'data-next': 'pin_2',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_2"
										value={this.state.pin_2}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress()}
										type={'number'}
										inputProps={{
											'data-next': 'pin_3',
											'data-previous': 'pin_1',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_3"
										value={this.state.pin_3}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress()}
										type={'number'}
										inputProps={{
											'data-next': 'pin_4',
											'data-previous': 'pin_2',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_4"
										value={this.state.pin_4}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress(onClose)}
										type={'number'}
										inputProps={{
											'data-previous': 'pin_3',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
							</div>
							<div style={{justifyContent: 'flex-end'}} className="react-confirm-alert-button-group">
								<div>
									<button onClick={() => {
										this.doing = null;
										this.doingFor = null;
										this.state.pin_1 = '';
										this.state.pin_2 = '';
										this.state.pin_3 = '';
										this.state.pin_4 = '';
										this.state.location = '';
										this.state.location_error = '';
										onClose();
									}} style={{marginRight: '0', marginLeft: '10px'}} className={'btn btn-default'}>Cancel
									</button>
									<button style={{marginRight: '0', marginLeft: '10px'}} className={'btn btn-success'}
										onClick={() => {
											this.handleUnlock();
											onClose();
										}}
									>
										Unlock
									</button>
								</div>
							</div>
						</div>
					</div>
				);
			}
		});
		let firstPin = document.getElementsByName('pin_1')[0] || null;
		if (firstPin && firstPin.value === '') {
			firstPin.focus();
		}
	};

}
